module.exports = __webpack_public_path__ + "static/img/menu-product-luolan.28edbd1e.png";